var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectOnboarded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#E7F7ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2591_1620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 24.5L20.9605 25.6686C21.3088 25.9472 21.8146 25.9022 22.1083 25.5666L24.4999 22.8334M28.6665 17.8334V18.6667H15.3332V16.1667C15.3332 14.786 16.4525 13.6667 17.8332 13.6667H19.9742C20.5309 13.6667 21.0717 13.8525 21.5108 14.1947L22.2945 14.8054C22.7336 15.1475 23.2744 15.3334 23.8311 15.3334H26.1665C27.5472 15.3334 28.6665 16.4526 28.6665 17.8334ZM14.8948 18.6667H29.1049C30.166 18.6667 30.9569 19.645 30.7346 20.6826L29.2312 27.6984C28.9018 29.2354 27.5436 30.3334 25.9718 30.3334H18.0279C16.4561 30.3334 15.0979 29.2354 14.7686 27.6984L13.2652 20.6826C13.0428 19.645 13.8338 18.6667 14.8948 18.6667Z",
    stroke: "#088B3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2591_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectOnboarded);
export default __webpack_public_path__ + "static/media/project_onboarded.b14e5ca867ff51db90db532b52e860cc.svg";
export { ForwardRef as ReactComponent };